import React from 'react';
import {List,Divider, Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {JoinedRoomData} from '@/redux-store/slices/matrix/room-data';
import DialogWithCloseIcon from '@/components/ui/dialogs/dialog-with-close-icon';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import MatrixUnreadEventsProvider from '@/contexts/matrix/unread-events/provider';
import ChatItem from './chat-item';


interface AllChatsDialogProps {
  open: boolean;
  onClose: () => void;
  chats: JoinedRoomData[];
}

const AllChatsDialog: React.FC<AllChatsDialogProps> = ({
  open,
  onClose,
  chats
}) => {
  const {t} = useTranslation();

  return (
    <DialogWithCloseIcon open={open} onClose={onClose} maxWidth="md">
      <Box sx={{my: 2, maxHeight: 500, overflow: 'auto'}} id="scrollableDiv">
        {chats.length === 0 ? (
          <ResponsiveTypography>{t('no_chats')}</ResponsiveTypography>
        ) : (
          <List>
            {chats.map((chat, index) => (
              <React.Fragment key={chat.roomId}>
                <MatrixUnreadEventsProvider
                  roomId={chat.roomId}
                  key={chat.roomId}
                >
                  <ChatItem chat={chat} />
                  {index < chats.length - 1 && <Divider />}
                </MatrixUnreadEventsProvider>
              </React.Fragment>
            ))}
          </List>
        )}
      </Box>
    </DialogWithCloseIcon>
  );
};

export default AllChatsDialog;
